import type { DraftByOrgResponse } from '@on3/api';
import { StarRating } from 'components/UI/StarRating/StarRating';
import { Text } from 'components/UI/Typography/Text';
import { useRouter } from 'next/router';

import styles from './DraftByCategoryGroup.module.scss';
import { DraftItem } from './DraftItem';
import { DraftListHeader } from './DraftListHeader';

export const DraftByCategoryGroup = ({
  group,
  players,
}: DraftByOrgResponse) => {
  const router = useRouter();
  const { category } = router.query;
  const isGroupByStars = group && category === 'draft-by-rating';
  const isTopDraftPicks = category === 'top-draft-picks';

  return (
    <div className={styles.groupContainer}>
      {!isTopDraftPicks && (
        <Text className={styles.groupName} variant="overline">
          {isGroupByStars && <StarRating stars={+group} />}
          <span className={styles.groupText}>{group}</span>
          {!isGroupByStars && <span>({players?.length})</span>}
          {isGroupByStars && (
            <span className={styles.starsText}>
              stars({`${players?.length}`})
            </span>
          )}
        </Text>
      )}
      <DraftListHeader />
      <ul>
        {players?.map((draftPick) => {
          return <DraftItem draftPick={draftPick} key={draftPick?.key} />;
        })}
      </ul>
    </div>
  );
};
